import { useState } from 'react';

function useDurationFilter(initialSelectedFilters) {
  const durationFilter = initialSelectedFilters.find(
    (filter) => filter.uid === 'duration.items[]',
  );
  const durationFilterValue =
    durationFilter?.subOptions?.map(({ value }) => value) || [];
  const [durationOptions, setDurationOptions] =
    useState<string[]>(durationFilterValue);

  const onToggleDuration = (value: string) => {
    const isSelected = durationOptions.some((item) => item === value);
    if (isSelected) {
      setDurationOptions(
        (prevDuration) => prevDuration.filter((item) => item !== value) || [],
      );
    } else {
      setDurationOptions((prevDuration) => [...prevDuration, value]);
    }
  };

  return {
    durationOptions,
    onToggleDuration,
  };
}

export default useDurationFilter;
